export const COMMIT_HASH = 'e75c9a900ad25a9bd63332544a8e6677447f47df';
